/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Exportasexcel2Inputs */

const en_btn_exportasexcel2 = /** @type {(inputs: Btn_Exportasexcel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as Excel`)
};

/**
* | output |
* | --- |
* | "Export as Excel" |
*
* @param {Btn_Exportasexcel2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_exportasexcel2 = /** @type {((inputs?: Btn_Exportasexcel2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Exportasexcel2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_exportasexcel2(inputs)
});
export { btn_exportasexcel2 as "btn_exportAsExcel" }